export const ApiConfig = {
  baseUrl: process.env.NEXT_PUBLIC_API_BASE_URL || 'https://api.capcito.test'
}
